import { addToCart } from "../utils/utils.js";

import { isLoading, productModalSku, showProductModal } from "../stores.js";

export function keywordFilter(headerValue, rowValue, rowData, filterParams) {
    let keywords = [];
    if (headerValue) {
        keywords = headerValue.toLowerCase().split(" ");
    }
    let keywordsFound = [];

    keywords.forEach((keyword) => {
        keywordsFound.push(rowValue.toLowerCase().includes(keyword));
    });

    let allKeywordsFound = keywordsFound.every((keyword) => keyword);

    return allKeywordsFound;
}

export function dateFormatter(cell, formatterParams) {
    return dateFormatterSimple(cell.getValue());
}

export function dateFormatterSimple(date) {
    let dateParts = date.split("T")[0].split("-");
    let formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    return formattedDate;
}

export function productPictureLinkFormatter(cell, formatterParams) {
    let sku = cell.getValue();
    return `
        <a style="color: blue; font-weight: bold;" href="/pics/all/${sku}.jpg" target="_blank">
            <img src="/pics/resampled/${sku}.jpg" height="25" width="25" />
        </a>
    `;
}

export function numberFormatter(cell, formatterParams) {
    return numberFormatterSimple(cell.getValue());
}

export function numberFormatterSimple(number) {
    return Math.round(number).toLocaleString();
}

export function oneDecimalFormatter(cell, formatterParams) {
    return cell.getValue().toFixed(1);
}

export function percentFormatter(cell, formatterParams) {
    return `${cell.getValue()}%`;
}

function debounce(callback, delay) {
    let timeout;

    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}

export function addToCartFormatter(cell) {
    let data = cell._cell.row.data;

    let cartQuantity = data.cartQuantity;
    let sku = data.sku;

    let inputGroup = document.createElement("div");
    inputGroup.className = "input-group";

    let input = document.createElement("input");
    input.type = "number";
    input.id = sku;
    input.value = cartQuantity;

    const updateValue = debounce((value) => {
        addToCart(sku, value || 0);
    }, 500);

    input.addEventListener("input", (e) => {
        console.log("input");
        let quantity = e.target.value;
        updateValue(quantity);
    });

    inputGroup.appendChild(input);

    return inputGroup;
}

export function openProductModal(e, cell) {
    let data = cell._cell.row.data;
    let sku = data.sku;

    // router(`/products/${sku}`);

    productModalSku.set(sku);
    showProductModal.set(true);
}

// const searchPlaceholder = "⌕";

// function linkFormatter(cell, formatterParams) {
//     cell._cell.element.style.color = "#547dc1";
//     return cell.getValue();
// }

// function highlightTitleFormatter(cell, formatterParams) {
//     cell.getElement().style.color = "red";
//     return cell.getValue();
// }
